export const statusIdNameCompare = {
  1: 'New',
  2: 'Active',
  3: 'Stopped',
  'default': 'Status unknown'
}

export default function getSubscriptionsStatusName(id) {
  return (statusIdNameCompare[id] || statusIdNameCompare['default'])
};
